import { render, staticRenderFns } from "./term.vue?vue&type=template&id=d8a51fbc&"
import script from "./term.vue?vue&type=script&lang=js&"
export * from "./term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports